enum BiteLogExpoPrinterEvent {
  GetPrintJobsSuccessWithOrders = 1,
  SetPrintResponse = 2,
}

export { BiteLogExpoPrinterEvent };
